export const setTileIds = products => {
  const timesSeenMap = {};
  products.forEach(product => {
    const { id } = product;
    timesSeenMap[id] ||= 0;
    const timesSeenBefore = timesSeenMap[id]++;
    product.tileId = `${id}${timesSeenBefore ? `-${timesSeenBefore + 1}` : ""}`;
  });
};
